<template>
    <div style="position: relative">
        <el-dialog :visible.sync="show" width="500px" :before-close="closeDialog" center :close-on-click-modal="false">
            <el-form ref="form" :model="search_data" label-width="96px">


                <el-row>
                    <el-col :span="22" style="margin-bottom:20px">
                        <el-form-item label="名称：">
                            <el-input v-model="name" placeholder="请输入值" disabled></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="22" style="margin-bottom:20px">
                        <el-form-item label="值：">
                            <el-input v-model="search_data.conf_value" placeholder="请输入值"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

            </el-form>

            <!-- 对话框底部按钮 -->
            <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="editConfSubmit">确定</el-button>
            <el-button @click="closeDialog">取消</el-button>
         </span>
        </el-dialog>
    </div>
</template>
<script>
    var _this;
    export default {

        props: {

            isShow: true,
            // 接受父组件传过来的值
            editRole_data: ''

        },
        // 监听传过来的iShow
        watch: {

            isShow(newData, oldData) {

                _this.show = true;

                // _this.getConfMode();
                console.log(_this.editRole_data);

                _this.search_data.conf_value = _this.editRole_data.conf_value;

                _this.search_data.conf_code = _this.editRole_data.conf_code;

                _this.name = _this.editRole_data.name;

                _this.city_name = _this.editRole_data.city.name;

            }

        },

        data() {

            return {
                city_name: '',

                // 所属模块绑定的值
                options: [],
                // 控制右侧抽屉
                show: false,

                name: '',

                search_data: {
                    conf_value: '',
                    conf_code: ''
                },
                search_rules: {
                    conf_code: {
                        placeholder: '配置编码',
                        rules: {
                            required: true,
                            message: '配置编码必须为8-20位',
                            regulation: 'between_str',
                            rulesData: [8, 20]
                        }
                    },

                    conf_value: {
                        placeholder: '值',
                        rules: {
                            required: true,
                            message: '1000位以内',
                            regulation: 'special',
                            rulesData: 'conf_value'
                        }
                    }
                }
            };

        },

        created() {
            _this = this;
        },

        methods: {
            closeDialog() {
                for (const key in _this.search_data) {
                    _this.search_data[key] = '';
                }
                _this.show = false;
            },

            getConfMode() {
                _this.$post(
                    '/system/getConfMode'
                ).then(res => {

                    _this.options = res.data;


                }).catch((err) => {

                });
            },

            // 添加配置
            editConfSubmit() {
                _this.$post(
                    '/conf/editConfSubmit',
                    _this.search_data,
                    _this.search_rules
                ).then(res => {
                    _this.show = false;

                    _this.$message.success('编辑' + res.msg);

                    var return_data = {
                        page: 1,
                        limit: 10
                    };
                    _this.$nextTick(function() {
                        _this.$emit('submit_ok_return');

                    });

                }).catch((err) => {

                });
            }
        }

    };
</script>
<style scoped>

</style>